"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.successResponse = exports.successResultResponse = void 0;
const successResultResponse = (result) => ({
    success: result,
});
exports.successResultResponse = successResultResponse;
exports.successResponse = { success: true };
//# sourceMappingURL=success-response.js.map